<template>
  <div class="footer" style="position: fixed; bottom: 0px; left: 0; z-index: 999; width: 100%; background-color: #000;">
    <el-row :span="24" type="flex" style="" justify="center" align="middle">
      <!-- <el-col :span="6" type="flex" align="middle">
        <router-link to="PageUpdate">
          <div><i class="el-icon-upload"></i></div>
          <div>최신</div>
        </router-link>
      </el-col> -->
      <el-col :span="6" type="flex" align="middle">
        <router-link to="PageType?type=1">
          <div><i class="el-icon-s-ticket"></i></div>
          <div>영화</div>
        </router-link>
      </el-col>
      <el-col :span="6" type="flex" align="middle">
        <router-link to="PageType?type=2">
          <div><i class="el-icon-video-camera-solid"></i></div>
          <div>드라마</div>
        </router-link>
      </el-col>
      <el-col :span="6" type="flex" align="middle">
        <router-link to="PageType?type=3">
          <div><i class="el-icon-s-flag"></i></div>
          <div>예능</div>
        </router-link>
      </el-col>
      <el-col :span="6" type="flex" align="middle">
        <router-link to="PageFIFA">
          <div>⚽︎</div>
          <div>스포츠분석</div>
        </router-link>
      </el-col>
      
      <!-- <el-col :span="6" type="flex" align="middle">
        <router-link to="PageType?type=5">
          <div><i class="el-icon-bicycle"></i></div>
          <div>애니</div>
        </router-link>
      </el-col> -->
      <!-- <el-col :span="6" type="flex" align="middle">
        <a href="http://utt131.com" target="_blank">
          <div><i class="el-icon-present"></i></div>
          <div>릴게임</div>
        </a>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'FootNav',
  props: {
    msg: String
  }
}
</script>


<style>
.footer{
  font-family: '(한)문화방송';
  font-size: 15px;
  padding: 5px 0;
  border-top: 1px solid #F56C6C;
  color: rgb(255, 215, 0);
  /* font-weight: bold; */
  .icon{
    font-size: 22px;
  }
}
</style>
